// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5WQjS","noUsersDataContainer":"styles_noUsersDataContainer__PKpmv","text":"styles_text__GB-cY"};